import { useEffect, useState } from 'react';
import axios from 'axios';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import PDF from './PdfDocument';

import { styled, Box, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { usePartnerGetMyTransactionSummaryPatientStatement } from 'hooks/requests/usePartnerGetMyTransactionSummaryPatientStatement';

/** 
*@param props {{
  accountNumber: PartnerGetMyTransactionSummaryPatientStatementPayload, 
  open: boolean, 
  close: ()=>void
  }}
*/
export default function PatientStatement({ accountNumber, open, close }) {
  const { data, isLoading: loading } =
    usePartnerGetMyTransactionSummaryPatientStatement(accountNumber);

  return (
    <StyledDialog
      open={open}
      PaperComponent={PaperComponent}
      maxWidth="lg"
      aria-labelledby="details"
    >
      <StyledDialogTitle id="details">
        <TitleControl>
          <Typography variant="h6">Patient Statement</Typography>
          <CloseIcon style={{ cursor: 'pointer' }} onClick={() => close()} />
        </TitleControl>
        {/* <Typography style={{fontSize: "0.7rem"}} variant="h6">{data.???}</Typography> */}
      </StyledDialogTitle>
      {!!loading && 'Loading ...'}
      {!loading && (
        <Box width="90vh" height={'90vh'} margin={'0 auto'} padding={'0 30px'}>
          <Stack justifyContent="flex-end" p="10px 0" direction="row">
            <PDFDownloadLink
              document={<PDF data={data} />}
              fileName={'patient-statement.pdf'}
              style={{
                color: '#4a4a4a'
              }}
            >
              {({ loading }) => (
                <>
                  {loading && 'Loading document...'}
                  {!loading && (
                    <Tooltip
                      title="Download"
                      sx={{
                        fontSize: '14px'
                      }}
                    >
                      <IconButton aria-label="patient-statement-download">
                        <CloudDownloadIcon style={{ color: '#1779ba' }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </>
              )}
            </PDFDownloadLink>
          </Stack>
          <PDFViewer
            style={{
              width: '100%',
              height: 'calc(100% - 100px)',
              margin: '0 auto'
            }}
          >
            <PDF data={data} />
          </PDFViewer>
        </Box>
      )}
    </StyledDialog>
  );
}

function PaperComponent(props) {
  return (
    <Draggable handle="#details" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const StyledDialogTitle = styled(DialogTitle)`
  cursor: move;
  position: sticky;
  top: 0;
  background-color: #f5f5f5;
`;
const TitleControl = styled('div')`
  display: flex;
  justify-content: space-between;
`;
const StyledDialog = styled(Dialog)`
  .MuiPaper-root.MuiDialog-paper {
    background-color: #f5f5f5;
    border: 6px solid #95bcd7;
  }
`;
